<template>
  <div
    class="video-unmute-overlay stick-all-corners"
    @click="handleClick"
    @mousedown="() => active = true"
    @mouseup="() => active = false"
    @mouseover="() => hover = true"
    @mouseout="() => hover = false"
    @touchstart="() => touch = true"
    @touchend="() => touch = false"
    @focus="() => focus = true"
    @blur="() => focus = false"
  >
    <VideoInPlayerOverlayButton
      class="unmute-button"
      alignment="left"
      :focus="active || hover || focus || touch"
    >
      <VsIcon icon="md:volume_off" />
      <span class="hint">{{ $t('unmute') }}</span>
    </VideoInPlayerOverlayButton>
  </div>
</template>

<script>
import VsIcon from '@/scripts/Components/Molecules/VsIcon';
import VideoInPlayerOverlayButton from '@/scripts/Components/Molecules/VideoInPlayerOverlayButton.ts.vue';

export default {
  i18n: {
    en: {
      unmute: 'Tap to unmute',
    },
    id: {
      unmute: 'Aktifkan suara',
    },
    zh: {
      unmute: '取消靜音',
    },
  },
  components: {
    VsIcon,
    VideoInPlayerOverlayButton,
  },
  data() {
    return {
      active: false,
      hover: false,
      focus: false,
      touch: false,
    };
  },
  methods: {
    handleClick() {
      this.$emit('unmute');
    },
  },
};
</script>

<style lang="scss" scoped>
.unmute-button {
  // Positioning
  margin-top: 1em;
}
</style>
